import Http from '../API'

const simcard_profile = {
  state: {
    group_simcard_profile: [],
    group_simcard_profile_tree: [],
    simcard_profile_list: {},
    simcard_profile_data: {},
    list_change_simcard_profile: false,
    simcard_profile_filter: { mno: [], msisdn:[], iccid: [], imsi:[], status: [], sim_type: [], tariff_id: []},
    simcard_profile_list_checked: {},
  },
  getters: {
    getSimcardProfileGroups: (state) => {
      return state.group_simcard_profile
    },
    getSimcardProfileGroupsTree: (state) => {
      return state.group_simcard_profile_tree
    },
    getSimcardProfileGroupById: (state) => (id, parent) => {
      for (let i in state.group_simcard_profile) {
        if (+state.group_simcard_profile[i].id === +id) {
          return state.group_simcard_profile[i]
        }
      }
      if(!parent) {
        simcard_profile.mutations.groupSimcardProfileUpdate(state, [...state.group_simcard_profile,  {'name': 'unknown', 'id': id, 'status': 'unknw', parent: -1 }])
      }
      return  state.group_simcard_profile[state.group_simcard_profile.length - 1]
    },
    getSimcardProfileById: (state) => (id) => {
      if (state.simcard_profile_data[id] && state.simcard_profile_data[id].profile) {
        // if (state.simcard_profile_data[id].profile.ts) {
          return state.simcard_profile_data[id]
        // }
      } else {
        state.simcard_profile_data[id] = { profile: null, stats: { ts_start: -1, data: null }, load: true }
        return state.simcard_profile_data[id]
      }
    },
    getSimcardProfileLink: (state) => (id) => {
      return !!state.simcard_profile_list[id];
    },
    getSimcardProfileLinks: (state) => {
      return state.simcard_profile_list
    },
    getSimcardProfileListChange: (state) => {
      return state.list_change_simcard_profile
    },
  },
  mutations: {

    groupSimcardProfileUpdate (state, groups_simcard_profile) {
      state.group_simcard_profile = groups_simcard_profile
      let group = {}
      let id = 0
      for(let i in state.group_simcard_profile) {
        group[state.group_simcard_profile[i].id] = { ...state.group_simcard_profile[i], label: state.group_simcard_profile[i].name,  expanded: true }
      }

      for(let i in state.group_simcard_profile) {
        id = state.group_simcard_profile[i].id
        if(state.group_simcard_profile[i].parent !== -1) {

          if(group[state.group_simcard_profile[i].parent] === undefined ||  group[state.group_simcard_profile[i].parent].status === 'unknw') {
            group[id].parent = -1
          }
           else {
            if(group[state.group_simcard_profile[i].parent].children === undefined) {
              group[state.group_simcard_profile[i].parent].children = [];
            }
            group[state.group_simcard_profile[i].parent].children.push(group[id]);
          }
        }
      }

      let root_group  = []

      for(let i in group) {
        if(group[i].parent === -1 && group[i].status !== 'unknw') {
          root_group.push(group[i])
        }
      }

      state.group_simcard_profile_tree = root_group
    },

    setSimcardProfileFilter (state, filter) {
      if (filter === null) {
        return false
      }
      state.simcard_profile_filter = filter
    },

    addLinkGroupSimcardProfile (state, id) {
      if (state.simcard_profile_list[id] === undefined ) {
         state.simcard_profile_list[id] = {}
      }
      state.simcard_profile_list = {...state.simcard_profile_list}
    },

    deleteLinkSimcardProfile(state, link) {
      if (state.simcard_profile_list[link.id] !== undefined && state.simcard_profile_list[link.id]) {
        for (let i in state.group_simcard_profile) {
          if (+state.group_simcard_profile[i].id === +link.id ) {
            if (+state.group_simcard_profile[i].parent !== -1 ) {
              state.simcard_list[state.group_simcard_profile[i].parent] = {}
            }
            break;
          }
        }

        delete state.simcard_profile_list[link.id]
      }
      state.simcard_profile_list = {...state.simcard_profile_list}
    },

    deleteLinkGroupSimcardProfile (state, params) {

      for( let id of params.ids ) {
        if (state.simcard_profile_list[id] !== undefined ) {
          delete state.simcard_profile_list[id]
        }
      }
      if(params.parent !== undefined && +params.parent !== -1) {
        state.simcard_profile_list[params.parent] = {}
      }

      state.simcard_profile_list = {...state.simcard_profile_list}
    },

    updateSimcardProfileProfile (state, simcard_profile) {
      let oldSimcardProfile = state.simcard_profile_data[simcard_profile.data.id] ? state.simcard_profile_data[simcard_profile.data.id] : state.simcard_profile_data[simcard_profile.data.virtual_imsi] ? state.simcard_profile_data[simcard_profile.data.virtual_imsi] : state.simcard_profile_data[simcard_profile.data.imsi]

      let tmp = {...simcard_profile}
      delete tmp['ts']
      oldSimcardProfile['hash'] = JSON.stringify(tmp)
      oldSimcardProfile['profile'] = {...simcard_profile.data}

      oldSimcardProfile['load'] = false
      state.simcard_profile_data = {...state.simcard_profile_data}

      let name = ''
      if (name.trim() === '') {
        name = simcard_profile.data.msisdn
      }
      state.simcard_profile_list[simcard_profile.data.id] = {
        name: name,
        icon: 'mdi-subdirectory-arrow-right',
        path: '/simcard_profile/' + simcard_profile.data.id
      }
      state.simcard_profile_list = {...state.simcard_profile_list}
    },
    setNotExistSimcardProfile (state, id) {
      let oldSimcardProfile = state.simcard_profile_data[id]
      oldSimcardProfile.load = false
      state.simcard_profile_data = {...state.simcard_profile_data}
    },
    updateSimcardProfileSection (state, simcard_profile) {
      if (state.simcard_profile_data[simcard_profile.id] === undefined) {
        state.simcard_profile_data[simcard_profile.id] = simcard_profile
      }
      state.simcard_profile_data[simcard_profile.id]['section'] = simcard_profile.section
    },
    updateSimcardProfileStats (state, simcard_profile) {
      let oldSimcardProfile = state.simcard_profile_data[simcard_profile.id]
      oldSimcardProfile['stats'] = {...simcard_profile}
      state.simcard_profile_data = {...state.simcard_profile_data}
    },
    setSimcardProfileListChange (state, status) {
      state.list_change_simcard_profile = status
    },

    clearSimcardProfile (state) {
      state.simcard_profile_list = {}
      state.simcard_profile_filter = { mno: [], msisdn:[], iccid: [], imsi:[], status: [], sim_type: [], tariff_id: []}
      state.simcard_profile_list_checked = {}
    },
  },

  actions: {

    deleteLinkSimcardProfile (context, id) {
      context.commit('deleteLinkSimcardProfile', id)
    },

    addLinkGroupSimcardProfile (context, id) {
      context.commit('addLinkGroupSimcardProfile', id)
    },
    deleteLinkGroupSimcardProfile (context, params) {
      context.commit('deleteLinkGroupSimcardProfile', params)
    },
    async groupSimcardProfileUpdate () {
      await Http.simcard.getSimcardProfileGroups((response) => {
        this.commit('groupSimcardProfileUpdate', response.data)
        this.commit('donePreloadName', 'groupSimcardProfileUpdate')
      })
    },
    setSimcardProfileFilter (context, filter) {
      context.commit('setSimcardProfileFilter', filter)
    },
    updateSimcardProfileProfile (_, id) {
      Http.simcard.getSimcardProfile(id, (response) => {
        this.commit('updateSimcardProfileProfile', { ts: Date.now() + 60000, ...response })
      }, () => {
        this.commit('setNotExistSimcardProfile',  id)
      })
    },
    updateSimcardProfileSection (_, params) {
      this.commit('updateSimcardProfileSection', { id: params.id, section: params.section })
    },
    updateSimcardProfileStats (state, id, tsStart, tsEnd) {
      Http.simcard.getSimcardStats(id, tsStart, tsEnd, (response) => {
        this.commit('updateSimcardProfileStats', {id: id, ts_start: tsStart, ts_end: tsEnd, data: {...response.data}})
      })
      return false
    }
  }
}

export default simcard_profile
